module.exports = {
  baseUrl:
    'https://res.cloudinary.com/black-tech-pipeline/image/upload/f_auto,q_auto,dpr_auto',
  promo_transform: '/w_200',
  header_transform: '/w_700',
  meta_transform: '/w_300',
  featured_transform: '/c_scale',
}
